import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FavoriteService } from 'src/app/_shared/service/favorite.service';
import MESSAGE from 'src/assets/resource/strings.json';
import { FollowedPropertiesState } from '../../state/followed-properties.state';

@Component({
  selector: 'app-create-watch-list-sheet',
  templateUrl: './create-watch-list-sheet.component.html',
  styleUrls: ['./create-watch-list-sheet.component.scss'],
})
export class CreateWatchListSheetComponent implements OnInit, OnDestroy {
  createWatchListSheetActive = false;
  switchTable = true;
  csvFileColumns: string[] = ['name', 'validAddressCount'];
  csvRecordColumns: string[] = ['select', 'address', 'watchlistStatus'];
  filter: string = 'address';
  watchListForm: FormGroup;
  stringRes: any = MESSAGE;
  addToWatchListInProgress: boolean;
  selectedIdList = [];
  selectedAddressList = [];
  selectedRecordCount = 0;
  onDestroyNotifier$ = new Subject();

  constructor(
    private followedPropertiesState: FollowedPropertiesState,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private favoriteService: FavoriteService
  ) {}

  ngOnInit() {
    this.followedPropertiesState.openCreateWatchListSheet$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((status) => {
        this.createWatchListSheetActive = status;
      });
    this.watchListForm = this.formBuilder.group({
      watchListName: ['', Validators.required],
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  closeCreateWatchListSheet() {
    this.followedPropertiesState.openCreateWatchListSheetValue = false;
  }

  get watchListFormValidation() {
    return this.watchListForm.controls;
  }

  selectedRecords(records) {
    this.selectedAddressList = records;
    this.selectedRecordCount = records.length;
  }

  addToWatchList(formDirective: FormGroupDirective) {
    if (!this.watchListForm.valid) return false;
    this.addToWatchListInProgress = true;
    this.favoriteService
      .createGroup(this.watchListForm.value.watchListName)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: any) => {
          if (this.selectedAddressList && this.selectedAddressList.length) {
            let filterCommonState = [
              ...new Map(this.selectedAddressList.map((item) => [item['state'], item])).values(),
            ];
            let state = filterCommonState.map((record) => {
              return record['state'];
            });
            let pmxPropertyIds = this.selectedAddressList.map((record) => {
              return record['pmxPropertyId'];
            });
            let params = {
              PMXPropertyIdList: pmxPropertyIds,
              GroupIds: [res.id],
              stateList: state,
            };
            this.favoriteService
              .addFavorites(params)
              .pipe(takeUntil(this.onDestroyNotifier$))
              .subscribe((response: any) => {
                if (response) {
                  this.favoriteService.fetchFollowGroupList();
                }
                formDirective.resetForm();
                this.watchListForm.reset();
                this.selectedAddressList = [];
                this.closeCreateWatchListSheet();
              });
          } else {
            formDirective.resetForm();
            this.watchListForm.reset();
            this.selectedAddressList = [];
            this.closeCreateWatchListSheet();
          }
        },
        null,
        () => {
          this.addToWatchListInProgress = false;
        }
      );
  }

  openSnackbar(message, style) {
    this.snackBar.open(message, '', {
      duration: 3000,
      panelClass: [style],
      verticalPosition: 'top',
    });
  }
}
